import { render, staticRenderFns } from "./CmDProjects.vue?vue&type=template&id=5663bfab"
import script from "./CmDProjects.vue?vue&type=script&lang=js"
export * from "./CmDProjects.vue?vue&type=script&lang=js"
import style0 from "./CmDProjects.vue?vue&type=style&index=0&id=5663bfab&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports